<template>
  <nav class="navbar navbar-expand-md navbar-light border-bottom">
    <div
      id="navbarNavLower"
      class="collapse navbar-collapse"
    >
      <b-row>
        <div class="col-12 col-sm d-inline-block clearfix">
          <ul
            class="navbar-nav"
            role="navigation"
          >
            <li
              v-for="(navigationItem, index) in navigation"
              :key="index"
              class="nav-item dropdown"
            >
              <div v-if="navigationItem.isMerkliste && isLoggedIn">
                <navigation-bookmarks />
              </div>
              <div v-else-if="navigationItem.isLogin">
                <router-link
                  v-if="!isLoggedIn"
                  :to="getLoginUrl()"
                  class="nav-link text-dark font-weight-bold text-uppercase"
                  tabindex="10"
                  title="Login"
                >
                  Login
                </router-link>

                <button
                  v-if="isLoggedIn"
                  :title="$GetCurrentUserName()"
                  class="nav-link text-dark font-weight-bold text-uppercase overFlowEllipsis"
                  data-toggle="dropdown"
                  style="width: 50px; !important"
                  tabindex="10"
                >
                  <i
                    class="fas fa-user"
                    style="font-size: 16px"
                  />
                </button>

                <ul
                  v-if="isLoggedIn"
                  class="dropdown-menu mainMenu small"
                  style="margin: 0px; padding: 0px; font-size: small !important"
                >
                  <li>
                    <a
                      class="nav-link text-dark font-weight-bold text-uppercase"
                      @click="logout()"
                    >Logout</a>
                  </li>
                  <li>
                    <router-link
                      class="nav-link text-dark font-weight-bold text-uppercase"
                      to="/changePassword"
                    >
                      Passwort ändern
                    </router-link>
                  </li>
                </ul>
              </div>
              <div
                v-else-if="
                  !navigationItem.requiresLogin ||
                    (navigationItem.requiresLogin && isLoggedIn)
                "
              >
                <div data-toggle="dropdown">
                  <router-link
                    :title="navigationItem.title"
                    :to="navigationItem.href ? navigationItem.href : ''"
                    class="nav-link text-dark font-weight-bold text-uppercase"
                    tabindex="10"
                  >
                    <span>
                      <!-- Bedingtes erstes Badge - Gesetzliche Mindestlohn fehler -->
                      <v-badge
                        v-if="
                          navigationItem.id ===
                            'mainMenuItemContractAdministration' &&
                            $store.state.mindestLohnKonfiguration.AggregatedStates
                              .length > 0
                        "
                        :value="true"
                        color="red"
                        left
                        sm
                      >
                        <template v-slot:badge>
                          <span>!</span>
                        </template>
                        <span>
                          {{ navigationItem.displayName }}
                        </span>
                      </v-badge>

                      <!-- Bedingtes zweites Badge - Verträge und zuständigkeit -->
                      <v-badge
                        v-else-if="
                          navigationItem.id === 'mainMenuItemUserManagement' &&
                            contractsAndResponsibilitiesErrors > 0
                        "
                        :value="true"
                        color="red"
                        left
                        sm
                      >
                        <template v-slot:badge>
                          <span>!</span>
                        </template>

                        <span>{{ navigationItem.displayName }}</span>
                      </v-badge>

                      <span v-else>
                        {{ navigationItem.displayName }}
                      </span>
                    </span>
                  </router-link>
                </div>
                <ul
                  v-if="navigationItem.subMenu.length > 0"
                  class="dropdown-menu mainMenu small"
                  style="margin: 0px; padding: 0px; font-size: small !important"
                >
                  <li
                    v-for="(
                      subMenuItem, subMenuIndex
                    ) in navigationItem.subMenu"
                    :key="subMenuIndex"
                  >
                    <a
                      v-if="subMenuItem.href === 'gavServiceUrl'"
                      :href="gavServiceUrl"
                      class="nav-link text-dark font-weight-bold text-uppercase"
                    >{{ subMenuItem.title }}</a>
                    <a
                      v-else-if="subMenuItem.href === 'uniaServiceUrl'"
                      :href="uniaServiceUrl"
                      class="nav-link text-dark font-weight-bold text-uppercase"
                    >{{ subMenuItem.title }}</a>
                    <router-link
                      v-else
                      :title="subMenuItem.title"
                      :to="subMenuItem.href"
                      class="nav-link text-dark font-weight-bold text-uppercase"
                    >
                      <v-badge
                        v-if="
                          subMenuItem.id === 'subMenuItemMinLoanViolations' &&
                            $store.state.mindestLohnKonfiguration.States.length >
                            0
                        "
                        :value="true"
                        color="red"
                        left
                      >
                        <template v-slot:badge>
                          <span>{{
                            $store.state.mindestLohnKonfiguration
                              .AggregatedStates.length
                          }}</span>
                        </template>

                        <span>
                          {{ subMenuItem.displayName }}
                        </span>
                      </v-badge>

                      <v-badge
                        v-else-if="
                          subMenuItem.id ===
                            'subMenuItemContractsAndResponsibilities' &&
                            contractsAndResponsibilitiesErrors > 0
                        "
                        :value="true"
                        color="red"
                        left
                      >
                        <template v-slot:badge>
                          <span>{{ contractsAndResponsibilitiesErrors }}</span>
                        </template>

                        <span>
                          {{ subMenuItem.displayName }}
                        </span>
                      </v-badge>

                      <span v-else>
                        {{ subMenuItem.displayName }}
                      </span>
                    </router-link>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </b-row>
    </div>
  </nav>
</template>

<script>
import NavigationBookmarks from "@/components/navigation/NavigationBookmarks.vue";
import navigationJson from "@/assets/configuration/mainNavigation.js";
import { Logout, IsUserLoggedIn } from "@/services/user.service.js";
import { GetCantonalMinimumWageValidationStates } from "@/services/minimum.wage.services/canton.minimum.wages.js";
import { GetGavServiceUrl } from "@/services/contract.edition.service.js";
import { GetUniaServiceUrl } from "@/services/contract.edition.service.js";
import { GetContractsAndResponsibilities } from "@/services/user.crm.service";

export default {
  components: {
    NavigationBookmarks,
  },
  data() {
    return {
      navigation: navigationJson,
      isLoggedIn: false,
      polling: null,
      gavServiceUrl: "",
      uniaServiceUrl: "",
      contractsAndResponsibilitiesErrors: 0,
    };
  },
  mounted() {
    this.isLoggedIn = IsUserLoggedIn();
  },
  created() {
    this.getCantonalMinimumSalaryStates();
    this.polling = setInterval(this.getCantonalMinimumSalaryStates, 7200000); // every 2h check the state
    this.getGavServiceUrl();
    this.getUniaServiceUrl();
    this.getContractsAndResponsibilities();
  },
  methods: {
    getContractsAndResponsibilities() {
      GetContractsAndResponsibilities(
        "",
        true,
        "",
        "",
        "",
        0,
        1,
        1,
        (response) => {
          if (response.countContractsWithInactiveResponsible) {
            this.contractsAndResponsibilitiesErrors =
              response.countContractsWithInactiveResponsible;
          }
        },
        (error) => {
          this.errorObject = error;
        },
      );
    },

    getGavServiceUrl() {
      GetGavServiceUrl(
        (success) => {
          this.gavServiceUrl = `${success}/admin`;
        },
        () => {
          this.gavServiceUrl = "#";
        },
      );
    },
    getUniaServiceUrl() {
      GetUniaServiceUrl(
        (success) => {
          this.uniaServiceUrl = `${success}/admin`;
        },
        () => {
          this.uniaServiceUrl = "#";
        },
      );
    },
    getLoginUrl() {
      return "/login?source=" + this.$route.fullPath;
    },
    logout() {
      Logout();
      this.isLoggedIn = false;
      this.$router.push({
        path: this.getLoginUrl(),
        query: { source: this.$route.path },
      });
    },
    getCantonalMinimumSalaryStates() {
      GetCantonalMinimumWageValidationStates(
        (result) => {
          this.$store.commit("setStates", JSON.parse(JSON.stringify(result)));
          let aggregatedStates = [];
          result.map((state) => {
            let existingAggregation = aggregatedStates.find(
              (x) => x.configurationId == state.configurationId,
            );
            if (!existingAggregation) {
              aggregatedStates.push({
                ...state,
                tenants: [state.tenantId],
              });
            } else {
              existingAggregation.tenants.push(state.tenantId);
            }
          });

          this.$store.commit(
            "setAggregatedStates",
            JSON.parse(JSON.stringify(aggregatedStates)),
          );
        },
        (error) => {
          console.log("Status laden fehlgeschlagen: " + error);
        },
      );
    },
    beforeDestroy() {
      clearInterval(this.polling);
    },
  },
};
</script>

<style>
.v-badge__badge {
  width: 17px;
  height: 17px;
  font-size: 12px;
  margin-left: 5px;
}

.navbar-nav {
  margin-block-start: 0px !important;
  cursor: default;
}

.navbar-default .navbar-nav > div > li.dropdown:hover > a,
.navbar-default .navbar-nav > div > li.dropdown:hover > a:hover,
.navbar-default .navbar-nav > div > li.dropdown:hover > a:focus {
  background-color: rgb(231, 231, 231);
  color: rgb(85, 85, 85);
}

li.dropdown:hover > div > .dropdown-menu {
  display: block;
}

.dropdown-menu {
  width: auto !important;
}

.mainMenu {
  padding: 0px;
  margin: 0px;
  width: max-content;
  font-size: inherit;
  cursor: pointer;
}

.dropdown .nav-link:hover {
  background-color: #eee;
}

.dropdown .nav-link:hover {
  background-color: #eee;
}

.mainMenu a.nav-link:hover {
  background-color: #eee;
}

.overFlowEllipsis {
  width: 150px;
  white-space: normal;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
